import { useState, useRef } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../Utils/axiosInstance";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { uiAction } from "../Redux/Slices/uiSlice";
const useApiRequest = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState(null);
  const lastRequest = useRef({});
  const sendApiRequest = async (
    method,
    url,
    data = null,
    { onSuccess, onStatus3, onError, showToast = false } = {},
  ) => {
    if (loading) {
      return;
    }
    setLoading(true);
    setError(null);
    setResponse(null);
    // 🔁 Save for recall
    lastRequest.current = {
      method,
      url,
      data,
      options: { onSuccess, onStatus3, showToast, navigate },
    };
    try {
      const jsonData = JSON.stringify({ ...data });
      let res;
      if (method === "POST") {
        res = await axiosInstance.post(url, jsonData);
        // console.log("res  ", res)
      } else if (method === "GET") {
        const params = new URLSearchParams(data).toString();
        res = await axiosInstance.get(`${url}?${params}`);
      } else {
        throw new Error("Unsupported HTTP method");
      }
      // console.log("payload", data);
      const result = res.data;
      // console.log("reqResponse", result, url);
      setResponse(result?.data);
      setStatus(result.code);

      if (result?.code === "0") {
        showToast &&
          toast.success(result.message, {
            toastId: "success",
          });
        onSuccess?.(result);
      } else if (result?.code === "1") {
        onError?.();
        toast.error(result.message, {
          toastId: "error",
        });
        setError(result.message);
      } else if (result?.code === "2") {
        toast.error(result.message, {
          toastId: "error",
        });
        setError(result.message);
      } else if (result?.code === "3") {
        onStatus3?.(result);
        sessionStorage.clear();
        navigate("/login");
        dispatch(uiAction.updateAppType("Business"));
        toast.error(result.message, {
          toastId: "error1",
        });
      }
    } catch (err) {
      console.error("API error:", err);
      // toast.error(err?.Message || "Something went wrong.", {
      //   toastId: "error1",
      // });
      onError?.();
      setError("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };
  const recallRequest = () => {
    const { method, url, data, options } = lastRequest.current || {};
    if (method && url) {
      sendApiRequest(method, url, data, options);
    } else {
      console.warn("No previous API call to recall.");
    }
  };
  return {
    loading,
    response,
    error,
    status,
    sendApiRequest,
    recallRequest, // <-- exposed here
  };
};

export default useApiRequest;
